import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem
} from "@ng-bootstrap/ng-bootstrap";
import {RouterLink} from "@angular/router";
import {SpotfightEvent} from "../../core/models/models";
import {CountdownComponent} from "../countdown/countdown.component";
import {leagueLabel} from "../../core/models/leagues";

@Component({
  selector: 'app-event-accordion',
  standalone: true,
  imports: [
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem,
    RouterLink,
    CountdownComponent
],
  templateUrl: './event-accordion.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './event-accordion.component.scss'
})
export class EventAccordionComponent {
  @Input()
  events: SpotfightEvent[] | undefined;

  protected readonly leagueLabel = leagueLabel;
}
